import { render, staticRenderFns } from "./AddEditRole.vue?vue&type=template&id=6518d209&"
import script from "./AddEditRole.vue?vue&type=script&lang=js&"
export * from "./AddEditRole.vue?vue&type=script&lang=js&"
import style0 from "./AddEditRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports